//Import required libraries
import React, { useState }  from 'react';

//Import custom components
import AddImage from './components/AddImage'
import PicsTable from './components/PicsTable'
import VizAnalysis from './components/VizAnalysis'
// import ShowAllSwitch from './components/ShowAllSwitch'

//Import Data
import docsRaw from '../../../assets/data/docsInfo.json'
import { store } from '../../../store/initialState';
// import passwordJson from '../../../firebase/password.json'

//Import Hooks
import useFirestore from '../../../hooks/useFirestore';

//Import Styles
import './Admin.scss';

//Import Functions
import { addDateToDocs } from '../../../utils/utils'

let path = store.path;

const Admin = props => {

    let { docs } = useFirestore(path);

    const [userLogin, setUserLogin] = useState(true)   
    const [password, setPasword] = useState('')
    const [error, setError] = useState(null)
    const [filter, setFilter] = useState({
        showAll: 'all',
        categories: null,
        year: null,
    })
    
    //Add dates to docs
    // let docs = addDateToDocs(docsRaw)
    docs = addDateToDocs(docs);

    //Filter docs based on selection
    docs = docs.filter(obj => filter.showAll === 'all' ? true : obj.flag === filter.showAll) //showAll
    docs = docs.filter(obj => filter.year ? obj.shotYear === filter.year : obj); //year
    docs = docs.filter(obj => filter.categories ? obj.categories.includes(filter.categories) : obj) //categories
    console.log('DOCS', docs);
    console.log('FILTER', filter)
    
    const handleLogin = () => {
        if (password === "") {
            setUserLogin(true)
        } else {
            setError('Incorrect Password')
        }
    }

    return (
        <>
            {
                userLogin
                ?
                <div className="admin-container">
                    <div className='admin'>
                        <div className='admin-header'>
                            <h1 className='admin-title'>ADMIN</h1>
                        </div>
                        {/* <div className='admin-filter'>
                            <ShowAllSwitch filter={filter} setFilter={setFilter} />
                        </div> */}
                        {
                            docs.length>0 &&  
                            <div className='admin-body'>
                                <VizAnalysis docs={docs} filter={filter} setFilter={setFilter}/>
                                <AddImage />
                                <PicsTable docs={docs}/>
                            </div>
                        }
                        {/* <div className='admin-footer'>
                            <AddImage />
                        </div> */}
                    </div>
                </div>
                :  
                <div className='login'>
                    <label>Enter Password</label>
                    <input type='password' onChange={e => setPasword(e.target.value)}></input>
                    <button onClick={() => {handleLogin()}}>Login</button>
                    {
                        error && <p className='error'>{error}</p>
                    }
                </div>
            }
        </>
    )
}

export default Admin